import {
  Box,
  CircularProgress,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';

import { useAppSelector } from 'store';
import { equipesSelector, EquipeInterface } from 'store/reducers/equipes'; // ajuste o tipo

const useStyles = makeStyles(() => ({
  truncateText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
}));

interface TeamSelectFieldProps {
  value: string;
  style?: React.CSSProperties;
  onFilter: (equipe: EquipeInterface) => void;
  onReset: () => void;
}

export default function TeamSelectField({
  value,
  style,
  onFilter,
  onReset,
}: TeamSelectFieldProps) {
  const classes = useStyles();
  const { equipes = [], loadingEquipes } = useAppSelector(equipesSelector);

  const selectedEquipe = equipes.find(e => e.id === value) ?? null;

  const handleChange = (
    _event: React.ChangeEvent<Record<string, unknown>>,
    equipe: EquipeInterface | null,
  ) => {
    if (equipe) {
      onFilter(equipe);
    } else {
      onReset();
    }
  };

  return (
    <Autocomplete
      id="team-select-field"
      value={selectedEquipe}
      options={equipes}
      loading={loadingEquipes}
      size="small"
      onChange={handleChange}
      popupIcon={<ExpandMore style={{ fontSize: 18 }} />}
      closeText="Fechar"
      openText="Abrir"
      clearText="Limpar"
      getOptionLabel={option => option?.nome || ''}
      getOptionSelected={(option, value) => option.id === value.id}
      noOptionsText={
        <Typography variant="body2">Nenhuma equipe encontrada</Typography>
      }
      style={{ minWidth: 150, width: '100%', ...style }}
      renderOption={equipe => (
        <Box display="flex" alignItems="center">
          <span className={classes.truncateText}>{equipe.nome}</span>
        </Box>
      )}
      renderInput={params => (
        <TextField
          {...params}
          label="Equipe"
          variant="outlined"
          placeholder="Buscar equipe..."
          InputProps={{
            ...params.InputProps,
            endAdornment: loadingEquipes ? (
              <CircularProgress size={16} />
            ) : (
              params.InputProps.endAdornment
            ),
          }}
        />
      )}
    />
  );
}
